import styled from "styled-components";
import theme from "../../style/theme";
import {ImageData} from "../../utils/image/image-data";

interface Props {
    imageData: ImageData;
    index: number;
}

export const LargeLocationImagePreviewLargeCard: React.FC<Props> = (
    {
        imageData,
        index,
    }
) => {
    return (
        <LargeLocationImagePreviewLargeCardContainer
            imageUrl={imageData.url}
            index={index}
        >
            <IndexContainer>
                <IndexContent>{index + 1}</IndexContent>
            </IndexContainer>
        </LargeLocationImagePreviewLargeCardContainer>
    );
};

interface LargeLocationImagePreviewLargeCardContainerProps {
    imageUrl: string;
    index: number;
}

const LargeLocationImagePreviewLargeCardContainer = styled.div<LargeLocationImagePreviewLargeCardContainerProps>`
  position: relative;
  width: 14.75rem;
  height: 12.875rem;
  border-radius: 0.25rem;
  background: url(${(props) => props.imageUrl}) no-repeat center;
  background-size: cover;
`;

const IndexContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.625rem;
  min-width: 1.625rem;
  bottom: 0.5rem;
  right: 0.5rem;
  background: #00000099;
  border-radius: 0.25rem;
`;

const IndexContent = styled.div`
  font-weight: 600;
  font-size: 0.938rem;
  line-height: 1.125rem;
  color: ${theme.palette.primitives.white};
`;
